import {ACTION, CreateEditDraft} from './action-types';
import {CaseState} from 'app/area/case/types-store';
import { ActionMap} from 'app/area/case';
export const reducers: ActionMap = {

  [ACTION.CREATE_EDIT_DRAFT]: (state: CaseState, action: CreateEditDraft): CaseState => {
    return {
      ...state,
      fetching: true
    };
  }

};
